import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateBrandSettingMutationVariables = Types.Exact<{
  input: Types.UpdateBrandSettingInput;
}>;


export type UpdateBrandSettingMutation = { __typename?: 'RootMutationType', updateBrandSetting?: { __typename?: 'BrandSettingResult', brandSetting?: { __typename?: 'BrandSetting', id: string, primaryColor?: string | null, logoUrl?: string | null, logoForDarkBgUrl?: string | null, symbolUrl?: string | null, symbolForDarkBgUrl?: string | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const UpdateBrandSettingDocument = gql`
    mutation updateBrandSetting($input: UpdateBrandSettingInput!) {
  updateBrandSetting(input: $input) {
    brandSetting {
      id
      primaryColor
      logoUrl
      logoForDarkBgUrl
      symbolUrl
      symbolForDarkBgUrl
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type UpdateBrandSettingMutationFn = Apollo.MutationFunction<UpdateBrandSettingMutation, UpdateBrandSettingMutationVariables>;

/**
 * __useUpdateBrandSettingMutation__
 *
 * To run a mutation, you first call `useUpdateBrandSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandSettingMutation, { data, loading, error }] = useUpdateBrandSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrandSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBrandSettingMutation, UpdateBrandSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBrandSettingMutation, UpdateBrandSettingMutationVariables>(UpdateBrandSettingDocument, options);
      }
export type UpdateBrandSettingMutationHookResult = ReturnType<typeof useUpdateBrandSettingMutation>;
export type UpdateBrandSettingMutationResult = Apollo.MutationResult<UpdateBrandSettingMutation>;
export type UpdateBrandSettingMutationOptions = Apollo.BaseMutationOptions<UpdateBrandSettingMutation, UpdateBrandSettingMutationVariables>;